module.exports = __webpack_public_path__ + "static/img/untagsuccessbg.8935649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/untagsuccessbg.png
// module id = 1279
// module chunks = 0